export default __webpack_public_path__ + "static/media/Banner.d6eebabd.png";